var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"va-section-header"},[_c('h2',{staticClass:"va-section-header-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.actionText)?_c('a',{staticClass:"va-section-header-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('action')}}},[_vm._v(_vm._s(_vm.actionText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }